"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePageRecommendJobsSuccessEvent = exports.HomePageRecommendCitiesSuccessEvent = exports.HomePageClickSeeMoreJobsSuccessEvent = exports.HomePageClickViewDetailsSuccessEvent = exports.HomePageClickBookmarkSuccessEvent = exports.HomePageClickPleaseSubmitSuccessEvent = exports.HomePageClickSeeMoreCitiesSuccessEvent = exports.HomePageClickMatchedCitySuccessEvent = exports.HomePageLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class HomePageLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_LANDING_SUCCESS';
    }
}
exports.HomePageLandingSuccessEvent = HomePageLandingSuccessEvent;
class HomePageClickMatchedCitySuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_MATCHED_CITY_SUCCESS';
    }
}
exports.HomePageClickMatchedCitySuccessEvent = HomePageClickMatchedCitySuccessEvent;
class HomePageClickSeeMoreCitiesSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_SEE_MORE_CITIES_SUCCESS';
    }
}
exports.HomePageClickSeeMoreCitiesSuccessEvent = HomePageClickSeeMoreCitiesSuccessEvent;
class HomePageClickPleaseSubmitSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_PLEASE_SUBMIT_SUCCESS';
    }
}
exports.HomePageClickPleaseSubmitSuccessEvent = HomePageClickPleaseSubmitSuccessEvent;
class HomePageClickBookmarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.HomePageClickBookmarkSuccessEvent = HomePageClickBookmarkSuccessEvent;
class HomePageClickViewDetailsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_VIEW_DETAILS_SUCCESS';
    }
}
exports.HomePageClickViewDetailsSuccessEvent = HomePageClickViewDetailsSuccessEvent;
class HomePageClickSeeMoreJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_CLICK_SEE_MORE_JOBS_SUCCESS';
    }
}
exports.HomePageClickSeeMoreJobsSuccessEvent = HomePageClickSeeMoreJobsSuccessEvent;
class HomePageRecommendCitiesSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_RECOMMEND_CITIES_SUCCESS';
    }
}
exports.HomePageRecommendCitiesSuccessEvent = HomePageRecommendCitiesSuccessEvent;
class HomePageRecommendJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'HOMEPAGE_RECOMMEND_JOBS_SUCCESS';
    }
}
exports.HomePageRecommendJobsSuccessEvent = HomePageRecommendJobsSuccessEvent;
//# sourceMappingURL=home.events.js.map